import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  AdminCreateUserRequest,
  AdminUser,
  UpdateUserContactRequest,
  UpdateUserRolesRequest,
  UpdateUserStatusRequest,
} from '../models/admin-user';
import { Role } from '../models/role';
import { AuditLog } from '../models/audit-log';
import { ApiService } from './base-api/api.service';

@Injectable({ providedIn: 'root' })
export class AdminApiService {
  private readonly api = inject(ApiService);

  getUsers(): Observable<AdminUser[]> {
    return this.api.get<{ data: AdminUser[] }>('admin/users').pipe(
      map(response => response.data)
    );
  }

  getUser(id: string): Observable<AdminUser> {
    return this.api.get<{ data: AdminUser }>(`admin/users/${id}`).pipe(
      map(response => response.data)
    );
  }

  createUser(payload: AdminCreateUserRequest): Observable<AdminUser> {
    return this.api.post<{ data: AdminUser }>('admin/users', payload).pipe(
      map(response => response.data)
    );
  }

  updateUserRoles(userId: string, payload: UpdateUserRolesRequest): Observable<string> {
    return this.api.put<{ data: string }>(`admin/users/${userId}/roles`, payload).pipe(
      map(response => response.data)
    );
  }

  updateUserStatus(userId: string, payload: UpdateUserStatusRequest): Observable<string> {
    return this.api.put<{ data: string }>(`admin/users/${userId}/status`, payload).pipe(
      map(response => response.data)
    );
  }

  updateUserContact(userId: string, payload: UpdateUserContactRequest): Observable<string> {
    return this.api.put<{ data: string }>(`admin/users/${userId}/contact`, payload).pipe(
      map(response => response.data)
    );
  }

  getUserActivityLogs(userId: string): Observable<AuditLog[]> {
    return this.api.get<{ data: AuditLog[] }>(`admin/users/${userId}/activity`).pipe(
      map(response => response.data)
    );
  }

  getRoles(): Observable<Role[]> {
    return this.api.get<{ data: Role[] }>('admin/roles').pipe(
      map(response => response.data)
    );
  }

  updateRole(role: Role): Observable<Role> {
    return this.api.put<{ data: Role }>(`admin/roles/${role.id}`, role).pipe(map(response => response.data));
  }
}
